import { object, string, boolean, array, number, } from 'yup';
import { GroupRuleType } from '../../models';
const ruleSchema = object().shape({
    type: string()
        .oneOf(Object.values(GroupRuleType))
        .required('Rule type is required'),
    value: string().required('Rule value is required'),
    priority: number().required('Priority is required'),
});
export const groupSchema = object({
    title: string().required(`Title is required`),
    default: boolean().default(false).required(`Default is required`),
    description: string().nullable().optional().max(255, 'Description must be at most 255 characters'),
    rules: array()
        .of(ruleSchema)
        .test('unique-priority', 'Priority must be unique', array => {
        const priorities = array.map(item => item.priority);
        return priorities.length === new Set(priorities).size; // Checks for unique priorities
    })
        .required('Rules is required'),
});
//# sourceMappingURL=group.js.map